import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/unfinish`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/unfinish`;

export const URL = (jobId: number): RouteDefinition =>
	`${baseRoute}/${jobId}/unfinish`;
